export const mirthTasksExternalSteps = [
  {
    selector: "#clientFilter",
    content:
      "Your assigned client is pre-selected. This field shows which client's Mirth tasks you are viewing.",
  },
  {
    selector: "#environmentFilter",
    content:
      "Optionally filter tasks by specific environments. You can select multiple environments to narrow down your search.",
  },
  {
    selector: "#statusFilter",
    content:
      "Filter tasks by their current status: Created, In Progress, or Completed.",
  },
  {
    selector: "#mirth-tasks-date-range",
    content:
      "Filter tasks by their creation date using the Start Date and End Date fields.",
  },
  {
    selector: "#outcomeFilter",
    content:
      "Filter tasks by their outcome: Success or Failure.",
  },
  {
    selector: "#taskTypeFilter",
    content:
      "Filter by task type: Resend Messages, Delete Messages, or Export Messages.",
  },
  {
    selector: "#mirth-tasks-search-button",
    content:
      "Click 'Find Tasks' to search for tasks matching your filters.",
  },
  {
    selector: "#mirth-tasks-data-grid",
    content:
      "This table displays your tasks. Click 'View Task Details' on completed tasks to see detailed results.",
  },
];
